export const AUTH_USER = 'AUTH_USER';
export const AUTH_ERROR = 'AUTH_ERROR';
export const FETCH_PROFILE = 'FETCH_PROFILE';
export const FETCH_HINTS = 'FETCH_HINTS';
